import {
  FilterMode,
  EmailVerificationCreateMutationVariables,
  EmailVerification_OrderBy,
  EmailVerification,
  SortOrder,
  EmailVerification_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const emailVerificationService = {
  createOne: buildCreateOne(
    (
        emailVerificationCreateVariables: EmailVerificationCreateMutationVariables
      ) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.emailVerificationCreate(
          emailVerificationCreateVariables
        );
        return result.emailVerificationCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.emailVerificationOne({ id });
    return result.emailVerificationOne as EmailVerification;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EmailVerification_OrderBy[] | null = null,
    filter: EmailVerification_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EmailVerification_Filter | undefined;
    if (searchValue !== "") {
      where = {
        email: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.emailVerificationListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ email: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.emailVerificationListWithOffset
    ) as EmailVerification[];
    return { list, orderBy };
  },
};
